import { Reveal } from "@/components/Reveal";
import { Siren } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { useSite } from "@/context/SiteContext";

const SERVICES = [
  "Reparații sanitare",
  "Reparații electrice minore",
  "Montaj și fixare",
  "Uși și mobilier",
  "Silicon și etanșări",
  "Mici reparații de finisaje",
  "Reglaje și remedieri",
  "Intervenții la proprietăți",
  "Mentenanță periodică",
];

export default function InterventionsBand() {
  const { openQuote } = useSite();
  return (
    <section className="bg-ink-950 py-14 sm:py-20" data-testid="interventions-section">
      <div className="container-brox">
        <Reveal>
          <div className="relative border border-copper/40 bg-gradient-to-br from-copper/10 via-ink-900 to-ink-900 p-6 sm:p-10">
            <span className="absolute -top-3 left-6 flex h-9 w-9 items-center justify-center bg-copper text-ink-950">
              <Siren className="h-5 w-5" />
            </span>
            <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
              <div>
                <p className="eyebrow mb-3">BROX INTERVENȚII & MENTENANȚĂ</p>
                <h2 className="display-title text-3xl sm:text-4xl" data-testid="interventions-title">
                  Omul potrivit<br /><span className="text-copper">pentru problema ta.</span>
                </h2>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base" data-testid="interventions-copy">
                  Organizăm reparații mici, intervenții tehnice și lucrări de mentenanță, fără să mai fii tu
                  cel care caută meseriașul potrivit. Ne spui problema — noi identificăm soluția și direcționăm
                  cererea către specialistul potrivit.
                </p>
                <div className="mt-5 flex flex-wrap gap-1.5" data-testid="interventions-examples">
                  {SERVICES.map((x) => (
                    <span key={x} className="border border-white/10 bg-ink-950 px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-paper/60">
                      {x}
                    </span>
                  ))}
                </div>
                <p className="mt-5 border-l-2 border-copper/50 pl-4 text-xs leading-relaxed text-muted-foreground" data-testid="interventions-safety">
                  Acolo unde legea sau siguranța cere un profesionist autorizat, cererea ta este directionată
                  către specialistul autorizat potrivit — nu către un ocazional.
                </p>
              </div>
              <div className="flex flex-col justify-center border-t border-white/10 pt-6 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0">
                <p className="font-display text-2xl font-bold uppercase tracking-wide text-paper sm:text-3xl" data-testid="interventions-urgent-title">
                  AI O PROBLEMĂ URGENTĂ?
                </p>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base" data-testid="interventions-urgent-copy">
                  Spune-ne ce s-a întâmplat și unde. Noi identificăm soluția potrivită.
                </p>
                <button
                  onClick={() => openQuote({ request_type: "URGENT", source: "interventii" })}
                  className="btn-primary mt-7 w-full !bg-red-500 hover:!bg-red-600 sm:w-auto"
                  data-testid="interventions-cta"
                >
                  <Siren className="h-5 w-5" />
                  SOLICITĂ INTERVENȚIE
                </button>
                <p className="mt-4 flex items-center gap-2 text-xs text-paper/60">
                  <WhatsAppIcon className="h-4 w-4 text-wa" />
                  Te contactăm în maximum 15 minute.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
